import { useAppDispatch } from "~/hooks/reduxHooks";
import { addError, ErrorDetail } from "~/store/errorSlice";

export const useLogError = () => {
	const dispatch = useAppDispatch();
	const logError = (errorDetail: ErrorDetail) => {
		dispatch(addError(errorDetail));
	};

	return [logError];
};
